import { type Static, Type } from '@sinclair/typebox';
import { MongooseObjectIdOrStringSchema, MongooseRefSchema } from './common.dto.js';
import { PodcastDTOSchema } from './podcast.dto.js';
import { StripeAccountDTOSchema, StripeCustomerDTOSchema } from './stripe.dto.js';

export const UserSettingsDTO = Type.Object({
  spotlightSoundNotification: Type.Boolean(),
  spotlightVibrationNotification: Type.Boolean(),
});

export const UserDTOSchema = Type.Object({
  _id: Type.String(),
  deletionRequestDate: Type.Optional(Type.String()),
  email: Type.String(),
  invitationSetup: Type.Optional(
    Type.Object({
      additionalDataRequiredOnFirstLogin: Type.Optional(Type.Boolean()),
      channelsPendingVerification: Type.Optional(Type.Array(MongooseObjectIdOrStringSchema)),
      stripeSetupNeeded: Type.Optional(Type.Boolean()),
    }),
  ),
  ownedChannels: Type.Array(MongooseRefSchema(PodcastDTOSchema)),
  pseudo: Type.Optional(Type.String()),
  settings: UserSettingsDTO,
  stripeAccount: Type.Optional(StripeAccountDTOSchema),
  stripeCustomer: Type.Optional(StripeCustomerDTOSchema),
  subscribedChannels: Type.Array(MongooseRefSchema(PodcastDTOSchema)),
});

export type UserDTO = Static<typeof UserDTOSchema>;
